<div *ngIf="changeOrderDetails">
    <div class="order-summary-header" *ngIf="!showSummary">
        <div class="order-summary-header-inner">
            <div class="header-left">
                <div class="page-name">Change Order</div>
                <div class="page-description">Please review the changes to your order below</div>
            </div>
            <div class="header-right">
                <div class="header-right-order">Order ID</div>
                <div id="order-id" class="header-right-number">#{{ changeOrderDetails?.id }}</div>
            </div>
        </div>
    </div>

    <div class="order-summary-main order-summary-main-top-header" *ngIf="!showSummary">
        <form
            id="changeOrderForm"
            method="post"
            *ngIf="signatureForm"
            [formGroup]="signatureForm">
            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Origin</div>
                        <div class="summary-header-block__desc">This is the pickup location.</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Origin Address</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.origin?.address }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Origin City</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.origin?.city }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Destination</div>
                        <div class="summary-header-block__desc">This is the delivery location.</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Destination Address</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.destination?.address }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Destination City</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.destination?.city }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Origin Contact</div>
                        <div class="summary-header-block__desc">This is the person that we will contact on <br />the day of the pickup to make arrangements.</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Name</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.origin?.contactName }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">E-Mail</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.origin?.contactEmail }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Phone Number</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.origin?.contactPhone }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Destination Contact</div>
                        <div class="summary-header-block__desc">This is the person that we will contact <br />to coordinate delivery.</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Name</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.destination?.contactName }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">E-Mail</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.destination?.contactEmail }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Phone Number</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.destination?.contactPhone }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Price</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row--big">
                                <span class="info-block__row__header">Total Tariff</span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.price?.totalPrice | currency }}</span>
                            </div>
                            <div class="info-block__row" *ngFor="let payment of changeOrderDetails?.price?.payments">
                                <span class="info-block__row__header">{{ payment.key }}</span>
                                <span class="info-block__row__value">{{ payment.value }}</span>
                            </div>

                            <div class="info-block__row" *ngIf="changeOrderDetails?.specialTerms">
                                <!-- Special Terms -->
                                <span class="info-block__row__header">Special Terms</span>
                                <span class="info-block__row__value" type="text">
                                    {{ changeOrderDetails?.specialTerms }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Cargo</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Transport Type</span>
                                <span class="info-block__row__value info-block__row__value__state">
                                    {{ changeOrderDetails?.transportType }}
                                </span>
                            </div>
                            <div class="info-block__column">
                                <span class="info-block__row__header">Cargo :</span>
                                <!-- TODO: split before -->
                                <span class="info-block__row__value" *ngFor="let vehicle of changeOrderDetails?.vehicles">
                                    {{ vehicle }}
                                </span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">First Available Pickup Date<span class="highlight-symbol">*</span></span>
                                <span class="info-block__row__value">{{ changeOrderDetails?.firstAvailablePickup | date:'MM/dd/yyyy' }}</span>
                            </div>
                            <div class="header-block__desc">
                                <span class="highlight-symbol">* </span>This is the earliest date that the cargo will be available for pickup.
                                We will schedule your pickup inside of a pre-agreed upon window, but not before this date.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Acceptance</div>
                    </div>
                    <div class="header-block__desc mb-4">
                        <span class="info_important">*</span>By selecting "I Agree" and entering my full name as a binding electronic signature,
                        I understand that an electronic signature has the same legal effect and can be enforced
                        in the same way as a written signature. Furthermore, I hereby accept terms and conditions
                        of service as described in the "Terms & Conditions" section below.
                    </div>
                    <div class="info-block__acceptance overflow-auto">
                        <div class="info-block__main">
                            <div class="content-wrapper">
                                <div class="info-block__row--big">
                                    <span class="info-block__row__header terms-header">Accept Terms & Conditions</span>
                                </div>
                                <div class="info-block__column__tip  remove-border">
                                    <span [innerHTML]="configuration?.paymentConfiguration?.terms">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [formControl]="signatureControls.agree"
                                id="IAgreeCheckbox">
                            <label
                                class="form-check-label"
                                for="IAgreeCheckbox">
                                I Agree
                            </label>
                        </div>
                    </div>
                    <div
                        id="AcceptanceHiddenUnlessAgreedFields"
                        *ngIf="signatureControls.agree.value"
                    >
                        <div class="mt-4 border-container form-field-container">
                            <span class="border-text">Electronic signature</span>
                            <app-signature-input
                                inputId="signedBy"
                                placeholder="Electronic signature (Your full name)*"
                                [externalControl]="signatureControls.signedBy"
                                [formControl]="signatureControls.signedBy">
                            </app-signature-input>
                        </div>

                        <div class="mt-4 border-container">
                            <span class="border-text">Your IP address</span>
                            <input class="form-control" type="text" [formControl]="signatureControls.ip">
                        </div>

                        <div class="mt-4 border-container">
                            <span class="border-text">Agreed to terms on this day</span>
                            <input class="form-control" type="text" id="disabledAgreedToTerms" [formControl]="signatureControls.signedOn">
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                </div>
            </div>
        </form>
        <div class="order-summary-main order-summary-main-bottom-header">
            <div class="order-summary-main-inner">
                <div class="order-summary-main-button-container mt-5 mb-5">
                    <div class="order-summary-main-button">
                        <button
                            type="button"
                            id="signChangeOrderButton"
                            class="sign-button"
                            [disabled]="!signatureControls.agree.value || signingInProgress"
                            (click)="submit()"
                        >
                            <span>{{ signingInProgress ? 'Please Wait...' : 'Sign Change Order' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-order-summary
        *ngIf="showSummary"
        [orderId]="changeOrderDetails!.id"
        [orderType]="'change'"
    ></app-order-summary>
</div>
